import { Stack, Typography } from '@mui/material';
import { Analytic } from 'types/analytic';

import { Agent } from 'components/Analytics/Agent';

interface ILeaderboardProps {
  leaderboard: Analytic[];
}

export const Leaderboard = ({ leaderboard = [] }: ILeaderboardProps) => {
  return (
    <Stack
      overflow="auto"
      maxWidth="100%"
      sx={{
        border: '1px solid',
        borderColor: 'secondary.light',
        borderRadius: '20px',
        width: '100%',
      }}
    >
      <Stack
        pt={4}
        pb={2}
        px={3}
      >
        <Typography variant="h6">Leaderboard</Typography>
        <Typography
          variant="body1"
          sx={{
            marginTop: '8px',
            marginBottom: '20px',
          }}
        >
          Rankings are updated in real-time based on task completion count.
        </Typography>
        <Stack gap={2.5}>
          {leaderboard.map((agent, i: number) => (
            <Agent
              key={i}
              index={i}
              agent={agent}
            />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
